<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<h1 class="tocchaptitle"><a id="contents"></a>Contents</h1>
<p class="toc1"><a href="#/05dearreader#reader">Dear Reader</a></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c1">Be a Good Friend</a></p>
<p class="toc1"><a href="#/07chapter02#c2">Be a Part of Your Family</a></p>
<p class="toc1"><a href="#/08chapter03#c3">Be Your Best Self</a></p>
<p class="toc1"><a href="#/09chapter04#c4">Be Kind</a></p>
<p class="toc1"><a href="#/10chapter05#c5">Be Brave</a></p>
<p class="toc1"><a href="#/11chapter06#c6">Be Willing to Learn</a></p>
<p class="toc1"><a href="#/12chapter07#c7">Be a Dreamer</a></p>
<p class="toc1"><a href="#/13chapter08#c8">Be Inspired</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-contents.vue?01370471